const messages = {
		'ar': () => import('./src/translations/front-end/ar.json'),
'de-DE': () => import('./src/translations/front-end/de-DE.json'),
'el': () => import('./src/translations/front-end/el.json'),
'en': () => import('./src/translations/front-end/en.json'),
'es-ES': () => import('./src/translations/front-end/es-ES.json'),
'et': () => import('./src/translations/front-end/et.json'),
'fr': () => import('./src/translations/front-end/fr.json'),
'it': () => import('./src/translations/front-end/it.json'),
'ja': () => import('./src/translations/front-end/ja.json'),
'ko': () => import('./src/translations/front-end/ko.json'),
'lt': () => import('./src/translations/front-end/lt.json'),
'lv': () => import('./src/translations/front-end/lv.json'),
'nl': () => import('./src/translations/front-end/nl.json'),
'pl': () => import('./src/translations/front-end/pl.json'),
'pt-BR': () => import('./src/translations/front-end/pt-BR.json'),
'pt-PT': () => import('./src/translations/front-end/pt-PT.json'),
'ru': () => import('./src/translations/front-end/ru.json'),
'tr': () => import('./src/translations/front-end/tr.json'),
'uk': () => import('./src/translations/front-end/uk.json'),
'vi': () => import('./src/translations/front-end/vi.json'),
'zh-CN': () => import('./src/translations/front-end/zh-CN.json'),
'zh-TW': () => import('./src/translations/front-end/zh-TW.json'),
	};

	module.exports = messages;
